<template>
  <div>
    <div
      class="container"
      v-if="module_settings && module_settings.is_active == false"
    >
      <div v-html="module_settings.inactive_message"></div>
    </div>
    <Store v-else v-if="ready" />
  </div>
</template>

<script>
import { get_configuration, get, error_message } from "@/utils";
import Store from "./store/Index.vue";

export default {
  components: {
    Store,
  },
  name: "OnlineStoreIndex",
  data() {
    return {
      ready: false,
      module_settings: undefined,
    };
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get("/online-store/settings", {})
      .then((conf) => {
        v.module_settings = conf;
        v.ready = true;
      })
      .catch((error) => {
        error_message(error);
        v.ready = true;
      })
      .finally(() => {
        v.$root.loader(false);
      });
    // setTimeout(() => {
    //   v.ready = true;
    // }, 500);

    // console.log(localStorage.getItem("permissions"));

    // v.$root.loader(true);
    // get("/system/settings", {})
    //   .then((r) => {
    //     localStorage.setItem("system_settings", JSON.stringify(r));
    //     if (r && r.free_use_urls)
    //       localStorage.setItem("permissions", JSON.stringify(r.free_use_urls));
    //       v.ready = true;
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //     error_message(err);
    //   })
    //   .finally(() => {
    //     v.$root.loader(false);
    //   });
  },
};
</script>

<style scoped>
.simple-component {
  text-align: center;
  margin-top: 20px;
}
</style>
